import { get, post } from './apiClient';
import {
    RequestAccessForm,
    directoryType,
    BusinessAccountsRequest,
    BusinessLocationsRequest,
    GrantAccessBody,
} from './types';

/* istanbul ignore next -- @preserve */
const isInDevBranchAndUserDoesNotWantProdApi = () =>
    (import.meta.env.VITE_API_REQUEST_ENV === 'development' || import.meta.env.DEV) &&
    window.USER_SET_API_ENV !== 'prod';

/* istanbul ignore next -- @preserve */
const getRequestAccessApiUrl = () => {
    let baseUrl = '';
    if (window.USER_SET_API_ENV === 'dev' || isInDevBranchAndUserDoesNotWantProdApi()) {
        baseUrl = 'https://development.request-access.com';
    } else {
        baseUrl = 'https://request-access.com';
    }

    return `${baseUrl}/api/listing-connect/public`;
};

/* istanbul ignore next -- @preserve */
const getTranslationsApiUrl = () => {
    let baseUrl = '';
    if (window.USER_SET_API_ENV === 'dev' || isInDevBranchAndUserDoesNotWantProdApi()) {
        baseUrl = 'https://dev.uberall.com/api';
    } else {
        baseUrl = 'https://uberall.com/api';
    }
    return `${baseUrl}/message-keys`;
};

const RequestAccessAPI = {
    fetchRequestAccessForm: async (
        directoryType: directoryType,
        accessId: string
    ): Promise<RequestAccessForm> => {
        const url = `${getRequestAccessApiUrl()}/directory/${directoryType}/access-request-forms/${accessId}`;

        return await get(url);
    },
    fetchTranslations: async (language: string): Promise<Record<string, string>> => {
        const url = getTranslationsApiUrl();

        return await get(url, { language });
    },
    fetchBusinessAccounts: async (
        directoryType: directoryType,
        params: Record<string, string>
    ): Promise<BusinessAccountsRequest> => {
        const url = `${getRequestAccessApiUrl()}/directory/${directoryType}/grant-accesses/accounts`;
        return await get(url, params);
    },
    fetchBusinessLocations: async (
        directoryType: directoryType,
        directoryUserAccountAccountId: string,
        params: Record<string, string>
    ): Promise<BusinessLocationsRequest> => {
        const url = `${getRequestAccessApiUrl()}/directory/${directoryType}/grant-accesses/accounts/${directoryUserAccountAccountId}/locations`;
        return await get(url, params);
    },
    grantAccess: async (directoryType: directoryType, body: GrantAccessBody) => {
        const url = `${getRequestAccessApiUrl()}/directory/${directoryType}/grant-accesses`;
        return await post(url, body);
    },
};

export { RequestAccessAPI, getRequestAccessApiUrl, getTranslationsApiUrl };
